import { each, compact, map } from 'lodash';
import { imageSrc, splitTextAndImages } from './qualify_helper';

const textWithImagesToPreloadMany = [
  'screenings', 'survey_metrics', 'custom_questions', 'scorings'
];
const textAndImagesToPreloadSingle = [
  'qualified_custom_text', 'task'
];
const fieldsSrcList = [ 'image_url', 'product_image_url' ];

const listToPreload = (data) => {
  const cdnHost = data.cdn_host;
  const srcItems = compact(
    map(fieldsSrcList, (field) => (data[field] ? { src: data[field] } : null))
  );

  each(textWithImagesToPreloadMany, (field) => {
    each(data[field] || [], (item) => {
      const textAndImages = splitTextAndImages(
        item.text || ''
      );
      each(textAndImages.content, (el) => {
        const { src } = imageSrc(el, textAndImages.images, cdnHost);
        if (src) {
          srcItems.push({ src });
        }
      });
    });
  });

  each(textAndImagesToPreloadSingle, (field) => {
    const textAndImages = splitTextAndImages(data[field] || '');
    each(textAndImages.content, (el) => {
      const { src } = imageSrc(el, textAndImages.images, cdnHost);
      if (src) {
        srcItems.push({ src });
      }
    });
  });

  return srcItems;
};

const runBasePreload = (data, changeLoadingState, addCustomPreload) => {
  const baseSrcList = listToPreload(data);

  addCustomPreload && addCustomPreload(baseSrcList);

  const numToLoad = baseSrcList.length;

  if (numToLoad) {
    let currentlyLoaded = 0;
    each(baseSrcList, (el) => {
      const img = new Image();
      img.onload = function () {
        currentlyLoaded += 1;
        if (currentlyLoaded === numToLoad) {
          changeLoadingState(false);
        }
      };
      img.src = el.src;
      el.callback && el.callback(img);
    });
  } else {
    changeLoadingState(false);
  }
};

export { runBasePreload };
